<template>
  <div class="booking-status">
    <div v-if="bookingLabel" class="status" style="text-overflow: ellipsis; white-space: nowrap; overflow-x: hidden; text-align: center;" :class="bookingLabel.class">
      {{ bookingLabel.label }}
    </div>
    <span v-if="booking.urgent" class="status status-bad">Urgent</span>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'

export default {
  mixins: [helpers],

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  computed: {
    bookingLabel () {
      switch (true) {
        case this.bookingIsContextuallyCancelled:
          return { class: 'status-bad', label: 'Cancelled' }
        case this.bookingIsContextuallyUnsuccessful:
          return { class: 'status-info', label: 'Unsuccessful' }
        case this.bookingIsContextuallyDeclined:
          return { class: 'status-bad', label: 'Declined' }
        case this.bookingIsContextuallyApplied && !this.$declineModuleEnabled:
          return { class: 'status-good', label: 'Accepted' }
        case this.bookingIsContextuallyApplied:
          return { class: 'status-good', label: this.$t('Applied') }
        case this.bookingIsOnHold:
          return { class: 'status-info', label: 'On Hold' }
        case this.bookingIsNotArchiveDraft:
          return { class: 'status-info', label: 'Incomplete' }
        case this.bookingIsDeclined:
          return { class: 'status-bad', label: 'Declined' }
        case this.bookingIsCompleted:
          return { class: 'status-good', label: 'Completed' }
        case this.bookingIsWithdrawn:
          return { class: 'status-bad', label: 'Withdrawn' }
        case this.bookingIsScheduled:
          return { class: 'status-info', label: 'Scheduled' }
        case this.bookingIsBooked:
          return { class: 'status-good', label: 'Booked' }
        case this.bookingHasExpired:
          return { class: 'status-bad', label: 'Expired' }
        case this.bookingIsVetting:
          return { class: 'status-info', label: 'Pending Approval' }
        case this.bookingIsPending:
          return { class: 'status-info', label: 'Pending' }
      }
      return null
    }
  }
}
</script>
